import { Box } from "@mui/material";

import { TextareaAutosize } from "@mui/material";
import { useTheme } from "@emotion/react";

import { setupManagementUrl } from "../../../config";
import DynamicTable from "../../../data/DynamicTable/dynamicTable";
import UOMForm from "./Form";
import { PaymentMethodsQuery, UOMQuery } from "../../../data/Axios/queries";

const base_url = setupManagementUrl.uri;
const actions = {
  entity: "Unit Of Measure",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: true,
    permission: "ActivatePermission",
    modelName: "unitofMeasureIds",
    inputObjectName: "bulkActivateDeactivateUnitofMeasure",
  },
  AssignTask: {
    key: "ASSIGN_TASK",
    button_name: "Assign Task",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2],
  },
  showStatus:true,
};
function UOMTable() {
 // const ignore = ["isActive"];
  return (
    <Box m="2px">
      <>
        <DynamicTable
          title="Unit Of Measure"
          subtitle="Manage unit of measure"
       //   ignoreFields={ignore}
          FormComponent={UOMForm}
          query={UOMQuery}
          base_url={base_url}
          actions={actions}
        />
      </>
    </Box>
  );
}

export default UOMTable;
